import { supabase } from '@/lib/supabase'

async function invokeFn(name: string, body?: any) {
  const { data, error, /* @ts-ignore */ response } = await (supabase.functions as any).invoke(name, { body })
  if (error) {
    try {
      const ctx: Response | undefined = (error as any)?.context || response
      if (ctx) {
        const ct = ctx.headers.get('content-type') || ''
        if (ct.includes('application/json')) {
          const j = await ctx.json().catch(() => null as any)
          const code = j?.error as string | undefined
          if (code) throw new Error(code)
        } else {
          const t = await ctx.text().catch(() => '')
          if (t) throw new Error(t)
        }
      }
    } catch {}
    throw new Error('Falha na Edge Function')
  }
  return (Array.isArray(data) ? (data as any)[0] : (data as any))
}

export type AffiliateInvite = {
  id: string
  email: string
  token: string
  code: string | null
  commission_mode: 'percent' | 'fixed' | null
  commission_value: number | null
  recurrence: 'one_time' | 'recurring' | null
  active: boolean
  expires_at: string | null
  used_at: string | null
  user_id: string | null
  created_at: string
  updated_at: string
}

export async function listAffiliateInvites(): Promise<{ items: AffiliateInvite[]; links: Array<{ id: string; link: string }> }> {
  const resp = await invokeFn('admin-affiliate-invites', { action: 'list' })
  return { items: resp?.items || [], links: resp?.links || [] }
}

export async function createAffiliateInvite(payload: { email: string; code?: string | null; commission_mode?: 'percent'|'fixed'|null; commission_value?: number | null; recurrence?: 'one_time'|'recurring'|null; expires_at?: string | null }) {
  return await invokeFn('admin-affiliate-invites', { action: 'create', ...payload } as any)
}

export async function updateAffiliateInvite(id: string, patch: Partial<{ active: boolean; expires_at: string | null }>) {
  return await invokeFn('admin-affiliate-invites', { action: 'update', id, ...patch } as any)
}

export async function deleteAffiliateInvite(id: string) {
  return await invokeFn('admin-affiliate-invites', { action: 'delete', id } as any)
}

export async function regenerateAffiliateInvite(id: string) {
  return await invokeFn('admin-affiliate-invites', { action: 'regenerate', id } as any)
}

